import React from 'react';
import styles from './CubeSpinner.module.css';

const CubeSpinner = () => {
  return (
    <div className={styles.spinner}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default CubeSpinner;